/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 15:06:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-13 12:14:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/common.ts
 */

import { fetchContentShoppingCartResetConfig } from './slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

export enum EnumCollapseId {
  emptyStateSetting = 'saleChannelContentShoppingCartPageEmptyStateSetting',
  buttonStyle = 'saleChannelContentShoppingCartPageButtonStyle',
  featuredProducts = 'saleChannelContentShoppingCartPageFeaturedProducts',
  noticeBoard = 'saleChannelContentShoppingCartPageNoticeBoard',
}
export const generateDefaultEmptyStateSetting = () => {
  return {
    image: null,
    text: '',
    background: '#ffffff',
  };
};

export const generateDefaultFeaturedProducts = () => {
  return { titleTextColor: '#000000', enabled: false };
};

export const generateDefaultButtonStyle = () => {
  return {
    text: '',
    backgroundColor: '#000000',
    textColor: '#000000',
    buttonThemeUuid: null,
  };
};

export const generateDefaultNoticeBoard = () => {
  return { enabled: false };
};

export const resetConfig = (data) => {
  const {
    //defaultState,

    key, // cb,
    dispatch,
  } = data || {};
  dispatch(
    fetchContentShoppingCartResetConfig({
      resetKey: key,
      params: { [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true },
    }),
  );
  // if (!defaultState) {
  //   dispatch(
  //     fetchContentShoppingCartResetConfig({
  //       uuid,
  //       resetKey: key,
  //       params: { [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true },
  //     }),
  //   );
  // } else {
  //   if (cb) cb();
  // }
};
